module.exports = __webpack_public_path__ + "files/c64d51f754539261ce150f6bef81611d.png";